import React, { useCallback } from 'react';
import { ScrollView, View, Text, StyleSheet } from 'react-native';
import { Ionicons as Icon } from '@expo/vector-icons';
import { CartContext } from '../../contexts/cart/Store';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import CartItem from './CartItem.tsx';
import { AnalyticsService } from '../../constants/Analytics';

import Colors from '../../constants/Colors'
import CompleteOrderButton from './CompleteOrderButton';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../StyledButton';
import DeliverySummary from '../common/DeliverySummary';
import { TransactionFeeNotice } from '../common/TransactionFeeNotice';
import useOrderTotal from '../../hooks/useOrderTotal';

const analytics = new AnalyticsService()

export default function () {
    const [state, , fetch] = React.useContext(CartContext)
    const navigation = useNavigation()

    const gotoProduct = () => {
        navigation.navigate('Home')
    }

    const totalCharge = React.useMemo(() => {
        const { totalCharge } = useOrderTotal(
            state.order_group,
            true
        );
        return totalCharge
    }, [state])

    useFocusEffect(
        useCallback(() => {
            fetch()
            return () => { }
        }, [])
    )

    return <>
        <ScrollView contentContainerStyle={styles.container}>
            {
                state &&
                    state.order_group_items &&
                    state.order_group_items.length
                    ? <>
                        {totalCharge.value > 0 && <TransactionFeeNotice amount={totalCharge.value} />}

                        <View style={styles.card}>
                            <View style={styles.cardTitleWrapper}>
                                <Text style={styles.cardTitleText}>{state.order_group_items.length} item{state.order_group_items.length > 1 ? 's' : null}</Text>
                            </View>
                            <View style={styles.hr}></View>
                            {
                                state.order_group_items.map(item =>
                                    <CartItem
                                        item={item}
                                        key={item._id}
                                    />)
                            }
                            <DeliverySummary order_group={state.order_group} isCart={true} />
                        </View>
                    </>
                    : <View style={styles.emptyContainer}>
                        <Icon name='md-basket' size={57.75} color='#CCC' style={{ padding: 9.62 }} />
                        <Text style={{
                            ...FontStyles.dark,
                            ...FontStyles.size16,
                            ...FontStyles.lh20,
                            ...FontStyles.bold,
                            textAlign: 'center',
                            marginTop: 8
                        }}>Empty Cart!</Text>
                        <Text style={{
                            width: 215,
                            color: Colors.shades._7,
                            ...FontStyles.size13,
                            ...FontStyles.lh18,
                            ...FontStyles.normal,
                            textAlign: 'center',
                            marginTop: 10
                        }}>You do not have any product in your cart.</Text>
                        <StyledButton
                            label="Start Shopping"
                            size="sm"
                            action={gotoProduct}
                            style={{
                                marginTop: 32,
                                minHeight: 42
                            }}
                        />
                    </View>
            }
            <CompleteOrderButton style={styles.completeOrderButtonStyle} />
        </ScrollView>
    </>
}

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.whiteColor
    },
    emptyContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 16,
        backgroundColor: Colors.whiteColor
    },
    hr: {
        height: 1,
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.05)',
    },
    card: {
        backgroundColor: Colors.whiteColor,
        paddingBottom: 10,
    },
    cardTitleWrapper: {
        flexDirection: 'row',
        paddingHorizontal: 16,
        paddingVertical: 16,
    },
    cardTitleText: {
        color: Colors.shades._7,
        ...FontStyles.size15,
        ...FontStyles.lh18,
        ...FontStyles.bold,
        flexGrow: 1,
        flex: 1
    },
    completeOrderButtonStyle: {
        padding: 16,
        marginBottom: 100,
        backgroundColor: Colors.whiteColor,
    }
});